import axios from 'axios';
import { ANALYZER_API_URL } from '../constants/api';

const base = `${ANALYZER_API_URL}/lspiv`;

const LspivService = {
    // ---------- job lifecycle ----------
    async createJob() {
        const { data } = await axios.post(`${base}/jobs`);
        return data;
    },
    async listJobs() {
        const { data } = await axios.get(`${base}/jobs`);
        return data.jobs;
    },
    async getJob(jobId) {
        const { data } = await axios.get(`${base}/jobs/${jobId}`);
        return data;
    },
    async deleteJob(jobId) {
        const { data } = await axios.delete(`${base}/jobs/${jobId}`);
        return data;
    },

    // ---------- video / frames ----------
    async uploadVideo(jobId, file, onProgress) {
        const form = new FormData();
        form.append('file', file);
        const { data } = await axios.post(`${base}/jobs/${jobId}/video`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (e) => {
                if (onProgress && e.total) {
                    onProgress(Math.round((e.loaded * 100) / e.total));
                }
            },
        });
        return data;
    },
    async extractFrames(jobId, params) {
        const { data } = await axios.post(`${base}/jobs/${jobId}/extract-frames`, params);
        return data;
    },
    async listFrames(jobId) {
        const { data } = await axios.get(`${base}/jobs/${jobId}/frames`);
        return data.frames;
    },
    frameUrl(jobId, name) {
        return `${base}/jobs/${jobId}/frames/${name}`;
    },

    // ---------- transformation ----------
    async uavTransformation(jobId, body) {
        const { data } = await axios.post(`${base}/jobs/${jobId}/transformation/uav`, body);
        return data;
    },
    async obliqueTransformation(jobId, body) {
        const { data } = await axios.post(`${base}/jobs/${jobId}/transformation/oblique`, body);
        return data;
    },
    async transformPoint(jobId, xPix, yPix) {
        const { data } = await axios.post(`${base}/jobs/${jobId}/transform-point`, {
            x_pix: xPix,
            y_pix: yPix,
        });
        return data;
    },

    // ---------- sections / masks ----------
    async saveSections(jobId, sections) {
        const { data } = await axios.post(`${base}/jobs/${jobId}/sections`, { sections });
        return data;
    },
    async getSections(jobId) {
        const { data } = await axios.get(`${base}/jobs/${jobId}/sections`);
        return data;
    },
    async createRoiMask(jobId, heightRoi, referenceImage) {
        const { data } = await axios.post(`${base}/jobs/${jobId}/roi-mask`, {
            height_roi: heightRoi,
            reference_image: referenceImage,
        });
        return data;
    },
    async createUserMask(jobId, index, points, referenceImage) {
        const { data } = await axios.post(`${base}/jobs/${jobId}/user-mask`, {
            index,
            points,
            reference_image: referenceImage,
        });
        return data;
    },
    async compileMasks(jobId) {
        const { data } = await axios.post(`${base}/jobs/${jobId}/compile-masks`);
        return data;
    },
    maskPreviewUrl(jobId, name) {
        return `${base}/jobs/${jobId}/mask-preview/${name}`;
    },

    // ---------- PIV ----------
    async pivTest(jobId, body) {
        const { data } = await axios.post(`${base}/jobs/${jobId}/piv-test`, body);
        return data;
    },
    async pivAnalyze(jobId, body) {
        const { data } = await axios.post(`${base}/jobs/${jobId}/piv-analyze`, body);
        return data;
    },
    async pivResults(jobId) {
        const { data } = await axios.get(`${base}/jobs/${jobId}/piv-results`);
        return data;
    },

    // ---------- discharge ----------
    async computeDischarge(jobId, body) {
        const { data } = await axios.post(`${base}/jobs/${jobId}/discharge`, body);
        return data;
    },
};

export default LspivService;
